<template>
    <div class="layout-vant-area">
        <van-area :area-list="areaList" @cancel="cancelArea" @confirm="confirmArea" />
    </div>
</template>

<script>
import area from '../../modules/data/base/area'
export default {
    name : 'VantArea',
    props: ['parentNode'],
    components: { },
    data(){
        return {
            areaList: area
        }
    },
    methods:{
        cancelArea() {
            if(this.parentNode && this.parentNode.name == 'StrongHome') {
                this.$store.state.strong.showStrongAreaPop = false;
                return;
            }
            if(this.parentNode && this.parentNode.name == 'Marriage') {
                this.$store.state.marriage.showLocation = false;
                return;
            }
            this.$store.state.collate.showArea = false;
        },
        confirmArea(data) {
            if(this.parentNode && this.parentNode.name == 'StrongHome') {
                this.$store.state.strong.showStrongAreaPop = false;
                this.$store.dispatch('user/confirmArea', data);
                return;
            }
            if(this.parentNode && this.parentNode.name == 'Marriage') {
                this.$store.dispatch('marriage/confirmArea', data);
                return;
            }
            // 起盘页面:更新表单的地区数据
            this.$store.state.collate.showArea = false;
            this.$store.dispatch('collate/confirmCollateArea', data);
            // 编辑页面:动态更新命盘数据
            if(this.parentNode && this.parentNode.name == 'EditDetail') {
                this.$store.dispatch('edit/updateEditDetail', 'location');
            }
        }
    }
}
</script>
